import Vue from "vue";

// axios
import axios from "axios";

let baseURL;

const prodURL =
    window.location.origin.includes("indsiders.com") &&
    !window.location.origin.includes("dev") &&
    !window.location.origin.includes("homolog");
const homologURL = window.location.origin.includes("homolog");
const localURL = window.location.origin.includes("localhost");
// URLs API PHP
if (prodURL) {
    baseURL = "https://api-php-v2.indsiders.com";
} else if (homologURL) {
    baseURL = "https://app-indsiders-myind-api-php-homolog.azurewebsites.net";
} else {
    baseURL = "https://app-indsiders-myind-api-php-dev.azurewebsites.net";
}

const axiosIns = axios.create({
    // You can add your headers here
    // ================================
    baseURL
    // timeout: 1000,
    // headers: {'X-Custom-Header': 'foobar'}
});

// URLs API .Net
if (prodURL) {
    baseURL = "https://api-v2.indsiders.com";
} else if (homologURL) {
    baseURL = "https://app-indsiders-myind-api-homolog.azurewebsites.net";
} else if (localURL) {
    baseURL = "https://app-indsiders-myind-api-dev.azurewebsites.net";
}
 else {
    baseURL = "https://app-indsiders-myind-api-dev.azurewebsites.net";
}

const evoAxiosIns = axios.create({
    baseURL: process.env.VUE_APP_API_V2_URL || baseURL
});

function attachMyIndAuthHeaders(config) {
    const userInfo = Vue.prototype.$cookies?.get("userInfo");
    const temporaryToken = userInfo?.temporaryToken || "";

    config.headers.Authorization = `Bearer ${temporaryToken}`;
    config.headers.token = temporaryToken;

    return config;
}

evoAxiosIns.interceptors.request.use(
    (config) => attachMyIndAuthHeaders(config),
    (error) => Promise.reject(error)
);

// Base separada: use apenas `$httpMyConnect` para os endpoints `/api/integration-agents/*`
// da API MyConnect. Demais chamadas continuam em `$http` (PHP) e `$http2` (.NET MyInd).
function getMyConnectBaseURL() {
    if (localURL) {
        return "https://localhost:7174";
    }
    if (prodURL) {
        return "https://app-indsiders-myconnect-api-prod.azurewebsites.net";
    }
    if (homologURL) {
        return "https://app-indsiders-myconnect-api-homolog.azurewebsites.net";
    }
    return "https://app-indsiders-myconnect-api-dev.azurewebsites.net";
}

const myConnectAxiosIns = axios.create({
    baseURL: getMyConnectBaseURL()
});

myConnectAxiosIns.interceptors.request.use(
    (config) => attachMyIndAuthHeaders(config),
    (error) => Promise.reject(error)
);

Vue.prototype.$http = axiosIns;
Vue.prototype.$http2 = evoAxiosIns;
Vue.prototype.$httpMyConnect = myConnectAxiosIns;

export default axiosIns;
